import { Component, Input, inject } from "@angular/core";
import { AggregateCriteria, IAggregate } from "@tylertech/tyler-api-types";

import { AggregateHelperService } from "../../services";

@Component({
    selector: "standard-task",
    templateUrl: "./standardTask.tmpl.html",
    standalone: false
})
export class StandardTaskComponent
{
    private readonly $aggregateHelperService = inject(AggregateHelperService);

    @Input()
    aggregate: IAggregate;

    @Input()
    aggregateCriteria: AggregateCriteria;

    get isHidden(): boolean
    {
        return this.$aggregateHelperService.isHidden(this.aggregate);
    }
}
